import Vue from 'vue'
import Vuex from 'vuex'
import url from './url'

Vue.use(Vuex)

const state = {
    userAccount: '',
    howIndex: 0,
    tagList: ['indexw'],
    tabOpen: 'indexw',
    menuOpen: '',
    subMenuOpen: '',
    subSubMenuOpen: '',
    homePageType: '',
    //===角色模块
    roleInfoArr:[],
    allMenuList: [],
    ...url
}

const mutations = {
    tagChange (state, name) {
      // 设置打开的标签
      state.tabOpen = name
      // 判断标签是否已经打开
      if (!state.tagList.includes(name)) {
        state.tagList.push(name)
      }
      sessionStorage.setItem('tabList', state.tagList)
      sessionStorage.setItem('tabShow', state.tabOpen)
    },
    tabSwitch (state, name) {
      state.tabOpen = name
      sessionStorage.setItem('tabShow', state.tabOpen)
    },
    // 关闭标签
    tabClose (state, name) {
      var delIndex = state.tagList.findIndex(function (value, index, arr) {
        return value === name
      })
      state.tagList.splice(delIndex, 1)
      if (state.tabOpen === name) {
        if (delIndex === state.tagList.length) {
          state.tabOpen = state.tagList[(delIndex - 1)]
        } else {
          state.tabOpen = state.tagList[delIndex]
        }
        sessionStorage.setItem('tabShow', state.tabOpen)
      }
      sessionStorage.setItem('tabList', state.tagList)
    },
    clearAllTags (state, name) {
      // state.tagList.length = 0
      state.tagList.splice(1, (state.tagList.length - 1))
      state.tabOpen = 'indexw'
      sessionStorage.setItem('tabShow', state.tabOpen)
      sessionStorage.setItem('tabList', state.tagList)
    },
    clearOtherTags (state, name) {
      // state.tagList.length = 0
      state.tagList.splice(1, (state.tagList.length - 1))
      if (state.tabOpen !== 'indexw') {
        state.tagList.push(state.tabOpen)
      }
  
      sessionStorage.setItem('tabList', state.tagList)
    },
    menuSet (state, menu) {     // 设置打开的一级菜单
      state.menuOpen = menu
      sessionStorage.setItem('menuShow', state.menuOpen)
    },
    subMenuSet (state, subMenu) {     // 设置打开的二级菜单
      if (subMenu !== '' && subMenu !== undefined) {
        state.subMenuOpen = subMenu
        sessionStorage.setItem('subMenuShow', state.subMenuOpen)
      } else {
        sessionStorage.removeItem('subMenuShow')
      }
    },
    subSubMenuSet (state, subSubMenu) {     // 设置打开的三级菜单
      if (subSubMenu !== '' && subSubMenu !== undefined) {
        state.subSubMenuOpen = subSubMenu
        sessionStorage.setItem('subSubMenuShow', state.subSubMenuOpen)
      } else {
        sessionStorage.removeItem('subSubMenuShow')
      }
    },
    getType (state, type) {
      state.homePageType = type
      sessionStorage.setItem('homeType', state.homePageType)
    },
    resetVuex (state) {
      state.tagList = ['indexw']
      state.tabOpen = 'indexw'
      state.menuOpen = ''
      state.subMenuOpen = ''
      state.subSubMenuOpen = ''
      sessionStorage.setItem('menuShow', state.menuOpen)
      sessionStorage.removeItem('subMenuShow')
      sessionStorage.removeItem('subSubMenuShow')
      sessionStorage.setItem('tabList', state.tagList)
      sessionStorage.setItem('tabShow', state.tabOpen)
    },
  
    createArr (state, id) {
      state.clickedTabArr[id] = []
    },
    layerComputed (state) {
      state.treeLayer = state.treeLayer + 1
    },
    //====角色模块存储
    roleInfoSave(state,roleInfoList){
      if (roleInfoList !== null && roleInfoList !== undefined) {
        state.roleInfoArr = roleInfoList 
        sessionStorage.setItem('roleInfoArr', state.roleInfoArr)
      } else {
        sessionStorage.removeItem('roleInfoArr')
      }
    },
    setMenuList(state, list) {
      state.allMenuList = list;
    }
  }

export default new Vuex.Store({
    state,mutations
})





// WEBPACK FOOTER //
// ./src/stores/store.js